<template>
    <div id="UserInfo">

        <van-popup v-model="showMapAddress" position="bottom" style="height:80%;" z-indx="1010">
            <map-search :city="searchCity" :callback-fun="afterSearchMapAddr"></map-search>
        </van-popup>

        <van-tabs v-model="tabActive">
            <van-tab title="新增收货信息">
                <van-cell-group>
                    <van-field
                            v-model="userInfo.username"
                            required
                            label="收货人"
                            placeholder="请输入姓名"
                    />
                    <van-field
                            v-model="userInfo.tel"
                            required
                            label="电话"
                            type="tel"
                            placeholder="请输入手机号"
                    />
                    <van-field
                            v-if="searchCity!='海外'"
                            v-model="userInfo.address"
                            type="textarea"
                            required
                            label="收货地址"
                            placeholder="请输入收货人地址"
                            readonly
                            @click="openMapAddress"
                    />
                    <van-field
                            v-if="searchCity=='海外'"
                            v-model="userInfo.address"
                            type="textarea"
                            required
                            label="收货地址"
                            placeholder="请输入收货人地址"
                    />
                    <van-field
                            v-model="userInfo.houseNo"
                            label="门牌号"
                            placeholder="请输入门牌、楼层房间号等信息"
                    />
                    <div class="button">
                        <div class="button-save" @click="clickSave()">保存</div>
                    </div>
                </van-cell-group>
            </van-tab>
            <van-tab v-if="userInfoList.length>0" title="从收货历史中选择">
                <van-list class="list">
                    <van-cell v-for="(item,index) in userInfoList" :key="index"  @click="clickOneAddr(item)">
                        <div class="address">{{item.location}},{{item.address}}</div>
                        <div class="contact">{{item.contact}}/{{item.tel}}</div>
                    </van-cell>
                </van-list>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { Popup,CellGroup,Field,Tab,Tabs } from 'vant';
    import 'vant/lib/popup/style';
    import 'vant/lib/cell-group/style';
    import 'vant/lib/list/style';
    import 'vant/lib/field/style';
    import 'vant/lib/tab/style';
    import 'vant/lib/tabs/style';

    Vue.use(CellGroup).use(Field).use(Tab).use(Tabs);

    import MapSearch from "./mapsearch"
    import http from "../../service/ServiceHttp"

    export default {
        name: "UserInfo",
        data() {
            return {
                showMapAddress:false,
                tabActive:0,
                userInfo:{
                    type:Object,
                    default:{
                        username: "",
                        tel: "",
                        address: "",
                        houseNo: "",
                        gdLng:"",
                        gdLat:""
                    }
                }
            }
        },
        props:{
          backSave:Function,
          searchCity:{
              type: String,
              default:"上海"
          },
          userInfoList: Array
        },
        methods:{
            clickSave(){
                if(!this.userInfo.username) return;
                if(!this.userInfo.tel) return;
                if(!this.userInfo.address) return;
                var obj = {
                    contact:this.userInfo.username,
                    tel:this.userInfo.tel,
                    location:this.userInfo.address,
                    address:this.userInfo.houseNo,
                    gdLng:this.userInfo.gdLng,
                    gdLat:this.userInfo.gdLat ,
                    isdefault:0
                };
                http.addUserTakeoutInfo(obj);
                this.backSave(this.userInfo);
            },
            openMapAddress(){
                this.showMapAddress = true;
            },
            clickOneAddr(item){
                var obj = {
                    username : item.contact,
                    tel : item.tel,
                    address : item.location,
                    houseNo : item.address,
                    gdLat : item.gdLat,
                    gdLng : item.gdLng
                };
                if(!obj.username) return;
                if(!obj.tel) return;
                if(!obj.address) return;
                this.backSave(obj);
            },
            afterSearchMapAddr(addr){
                if(!addr){
                    this.showMapAddress = false;
                    return;
                }
                this.userInfo.address = addr.city+addr.adName+addr.address;
                this.userInfo.gdLat = addr.gdLat;
                this.userInfo.gdLng = addr.gdLng;
                this.showMapAddress = false;
            }
        },
        mounted(){
        },
        components:{
            MapSearch
        }
    }
</script>

<style scoped lang="scss">
    #UserInfo {
        .list{
            .address{
                font-size: 0.9rem;
            }
            .contact{
                font-size:0.8rem;
                color:#323232;
            }
        }
        .button{
            position: fixed;
            left: 0;
            bottom: 0;
            right: 0;
            padding: 10px;
            .button-save{
                text-align: center;
                padding: 10px;
                border-radius: 50px;
                background: #F84743;
                color: #FFFFFF;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/takeoutDialog/userinfo.vue